<template>
    <div id="organizationMapBox">
        <div id="organizationMap"></div>
        <el-button @click="reDraw" style="margin-top: 10px"
            >重绘区域范围</el-button
        >
    </div>
</template>

<script>
import AMap from "AMap" // 引入高德地图
import { post } from "@/api/requrestHttp"
function noop() {}
export default {
    name: "organizationMap",
    props: {
        orgId: {
            default: null,
        },
        onSuccess: {
            type: Function,
            default: noop,
        },
        val: {
            default: "",
        },
    },
    components: {},
    data() {
        return {
            mouseTool: null,
        }
    },
    computed: {},
    methods: {
        reDraw() {
            let that = this
            let s = []
            that.onSuccess(s.join())
            if (this.polygon) {
                this.polygon.setMap(null)
            }
            this.mouseTool.close(true)
            this.mouseTool.polygon()
            var polygonArr = []
            var map = new AMap.Map("organizationMap", {
                mapStyle: "amap://styles/blue",
                //  mapStyle: "amap://styles/4f2131e7288788c62b63fc7957674ba0",
                zoom: 15,
                zooms: [3, 20],
                expandZoomRange: true,
                defaultCursor: "default",
                center: [117.494476, 30.64932], //初始化地图中心点
            })
            this.map = map
            var mouseTool = new AMap.MouseTool(map)
            this.mouseTool = mouseTool
            this.mouseTool.on("draw", function (e) {
                //监听draw事件可获取画好的覆盖物
                var overlays = []
                console.log("0000", e)
                if (polygonArr == true) {
                    var polygonArr2 = []
                    e.obj.getPath().forEach((element) => {
                        polygonArr2.push([element.lng, element.lat])
                    })
                    overlays.push(e.obj)
                    var isRingInRing = AMap.GeometryUtil.isRingInRing(
                        polygonArr2,
                        polygonArr
                    )
                    var doesRingRingIntersect =
                        AMap.GeometryUtil.doesRingRingIntersect(
                            polygonArr2,
                            polygonArr
                        )

                    if (!isRingInRing || doesRingRingIntersect) {
                        that.$message({
                            message: "请画出正确的网格地图",
                            type: "error",
                        })
                        mouseTool.close(true)
                        mouseTool.polygon({
                            fillColor: "#00b0ff",
                            strokeColor: "#80d8ff",
                            //同Polygon的Option设置
                        })
                    } else {
                        let s = []
                        polygonArr2.forEach((e) => {
                            s.push(`${e[0]}:${e[1]}`)
                        })
                        that.onSuccess(s.join())
                        // that.$emit("input", s.join());
                        // console.log(s.join());
                    }
                } else {
                    var polygonArr2 = []
                    e.obj.getPath().forEach((element) => {
                        polygonArr2.push([element.lng, element.lat])
                    })
                    overlays.push(e.obj)
                    let s = []
                    polygonArr2.forEach((e) => {
                        s.push(`${e[0]}:${e[1]}`)
                    })
                    console.log(polygonArr2)
                    that.onSuccess(s.join())
                }
            })
            this.mouseTool.polygon({
                fillColor: "#00b0ff",
                strokeColor: "#80d8ff",
                //同Polygon的Option设置
            })
        },
        mapInit(id) {
            let that = this
            var map = new AMap.Map(id, {
                mapStyle: "amap://styles/blue",
                //  mapStyle: "amap://styles/4f2131e7288788c62b63fc7957674ba0",
                zoom: 15,
                zooms: [3, 20],
                expandZoomRange: true,
                defaultCursor: "default",
                center: [that.orgId.longitude, that.orgId.latitude], //初始化地图中心点
            })
            this.map = map
            var polygonArr = []
            if (that.orgId.areaDivision) {
                that.orgId.areaDivision.split(",").forEach((e) => {
                    polygonArr.push(e.split(":"))
                })
            }

            var polygon = new AMap.Polygon({
                map: map,
                path: polygonArr, //设置多边形边界路径
                strokeOpacity: 0.2, //线透明度
                strokeWeight: 3, //线宽
                fillOpacity: 0.35, //填充透明度
            })
            this.polygon = polygon
            var mouseTool = new AMap.MouseTool(map)
            this.mouseTool = mouseTool
            this.mouseTool.on("draw", function (e) {
                //监听draw事件可获取画好的覆盖物
                var overlays = []
                console.log("0000", e)
                if (polygonArr == true) {
                    var polygonArr2 = []
                    e.obj.getPath().forEach((element) => {
                        polygonArr2.push([element.lng, element.lat])
                    })
                    overlays.push(e.obj)
                    var isRingInRing = AMap.GeometryUtil.isRingInRing(
                        polygonArr2,
                        polygonArr
                    )
                    var doesRingRingIntersect =
                        AMap.GeometryUtil.doesRingRingIntersect(
                            polygonArr2,
                            polygonArr
                        )

                    if (!isRingInRing || doesRingRingIntersect) {
                        that.$message({
                            message: "请画出正确的网格地图",
                            type: "error",
                        })
                        mouseTool.close(true)
                        mouseTool.polygon({
                            fillColor: "#00b0ff",
                            strokeColor: "#80d8ff",
                            //同Polygon的Option设置
                        })
                    } else {
                        let s = []
                        polygonArr2.forEach((e) => {
                            s.push(`${e[0]}:${e[1]}`)
                        })
                        that.onSuccess(s.join())
                        // that.$emit("input", s.join());
                        // console.log(s.join());
                    }
                } else {
                    var polygonArr2 = []
                    e.obj.getPath().forEach((element) => {
                        polygonArr2.push([element.lng, element.lat])
                    })
                    overlays.push(e.obj)
                    let s = []
                    polygonArr2.forEach((e) => {
                        s.push(`${e[0]}:${e[1]}`)
                    })
                    console.log(polygonArr2)
                    that.onSuccess(s.join())
                }
            })
            this.mouseTool.polygon({
                fillColor: "#00b0ff",
                strokeColor: "#80d8ff",
            })
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.mapInit("organizationMap")
        })
    },
    created() {},
    watch: {},
}
</script>
<style lang="less" >
#organizationMap {
    width: 100%;
    height: 470px;
}
</style>